import React, { Component } from 'react';

import { Marker } from 'google-maps-react';



class StationsList extends Component {

    componentDidMount = () => {
        this.loadStations();
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.ohlsList.length !== nextProps.ohlsList.length
            || this.props.zoomLevel !== nextProps.zoomLevel
            || this.props.showStations !== nextProps.showStations) {
            return true;
        }
        else {
            return false;
        }
    }


    componentDidUpdate = () => {
        this.loadStations();
    }

    loadStations = () => {
        let resultList = [];

        if (this.props.showStations && this.props.zoomLevel > 0) {
            const stationsList = this.filterStations(this.props.ohlsList);
            resultList = stationsList.map((station, index) =>
                <Marker
                    key={'Station' + index}
                    title={station.name}
                    name={station.name}
                    position={{ lat: station.position.lat, lng: station.position.lng }}
                    onClick={this.props.onStationClick}
                />)

        }

        this.props.sendChildElementDataToState(this.props.stateElementName, resultList);
    }

    filterStations = (ohlsList) => {

        let stationsList = [];
        if (ohlsList) {
            ohlsList.forEach(ohl => {
                let ohlStations = ohl.stanice;

                ohlStations.forEach(ohlStation => {
                    if (!stationsList.some(station => station.name === ohlStation.name)) {
                        stationsList.push(ohlStation)
                    }
                });
            });
        }

        // if(bounds){
        //     stationsList = stationsList.filter(station =>
        //         station.position.lat >= bounds.latMin
        //         && station.position.lat <= bounds.latMax
        //         && station.position.lng >= bounds.lngMin
        //         && station.position.lng <= bounds.lngMax
        //     );
        // }

        return stationsList;
    }

    render() {
        return null;
    }
}

export default StationsList;